import React from 'react';
import { MenuPopover, MenuItem, NotYetImplemented } from '../../components/ui';

/** The ··· menu on a saved task's step. */
export default function StepMenu({ step, onEditInstructions, onChangeModel, onCopyFromHere, onDelete }) {
  return (
    <MenuPopover label={`Actions for ${step.title}`}>
      <NotYetImplemented inline feature="partialRuns">
        <MenuItem>Run from this step</MenuItem>
      </NotYetImplemented>
      <NotYetImplemented inline feature="partialRuns">
        <MenuItem>Run just this step</MenuItem>
      </NotYetImplemented>
      <NotYetImplemented inline feature="taskRuns">
        <MenuItem>See last output</MenuItem>
      </NotYetImplemented>
      <MenuItem onClick={() => onEditInstructions(step)}>Edit instructions</MenuItem>
      <MenuItem onClick={() => onChangeModel(step)}>Change model or tool</MenuItem>
      <MenuItem onClick={() => onCopyFromHere(step)}>Copy to canvas from here</MenuItem>
      <NotYetImplemented inline feature="saveStepsAsTask">
        <MenuItem>Save steps from here as a task</MenuItem>
      </NotYetImplemented>
      <MenuItem danger onClick={() => onDelete(step)}>Delete step</MenuItem>
    </MenuPopover>
  );
}
